const mix_state     = process.env.MIX_TRACE_ENABLED;
const mix_enabled   = ( mix_state && mix_state !== 'false' );
const trace_enabled = ( 'console' in window && mix_enabled );

const trace = {
    log   : ( ...args ) => trace_enabled && console.log( ...args ),
    warn  : ( ...args ) => trace_enabled && console.warn( ...args ),
    info  : ( ...args ) => trace_enabled && console.info( ...args ),
    error : ( ...args ) => trace_enabled && console.error( ...args ),
    debug : ( ...args ) => trace_enabled && console.debug( ...args )
};

trace.info( 'Application: trace is active' );

export default trace;

